module.exports = __webpack_public_path__ + "img/users-blue.260bbd82.svg";